import React from "react";
import { Button } from "./ui/button";
import { PhoneCall, MapPin } from "lucide-react";
import { company } from "../mock";

export default function Mission() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden bg-slate-900 text-white p-8 md:p-14 border border-slate-800">
          <div className="absolute inset-0 bg-grid opacity-20" />
          <div className="absolute -top-20 -right-10 h-72 w-72 rounded-full bg-cyan-500/20 blur-3xl" />
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="text-xs uppercase tracking-widest text-cyan-400 font-bold">My Mission</div>
              <h2 className="mt-3 text-3xl md:text-4xl font-extrabold leading-tight">
                Revolutionizing digital marketing for small businesses.
              </h2>
              <p className="mt-5 text-slate-300 leading-relaxed">
                Top-tier AI websites, social media, SaaS and CRM automation consulting services. Innovative
                strategies that drive growth and visibility in the ever-evolving digital marketplace.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                <Button asChild className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 h-11 px-6 font-bold">
                  <a href={`tel:${company.phone}`}>
                    <PhoneCall className="mr-2 h-4 w-4" /> Call {company.phone}
                  </a>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  className="h-11 px-6 font-semibold border-slate-600 text-white hover:bg-slate-800"
                >
                  <a href="#contact">Let&rsquo;s Connect</a>
                </Button>
              </div>

              <div className="mt-6 flex items-center gap-2 text-sm text-slate-400">
                <MapPin className="h-4 w-4 text-cyan-400" />
                {company.location}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1000&q=80"
                alt="Eddie Kirk consulting"
                className="w-full h-52 sm:h-72 md:h-80 lg:h-[360px] object-cover object-left lg:object-center rounded-2xl border border-slate-700"
              />
              <div className="absolute -bottom-5 -left-5 bg-white text-slate-900 rounded-xl shadow-2xl p-4 w-56 hidden md:block">
                <div className="text-xs uppercase tracking-widest text-cyan-700 font-bold">Charity</div>
                <div className="font-bold mt-1">Giving Back Always</div>
                <div className="text-xs text-slate-500 mt-1">A portion of every dollar supports charities.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
